declare global {
    interface Window {
        _env_: any;
    }
}

export const applicationSettings = {
    applicationName: window._env_?.APPLICATION_NAME ?? 'Document Upload: Request UI',
    applicationVersion: window._env_?.APPLICATION_VERSION ?? '0.0.0.0',
    applicationInsightsInstrumentationKey: window._env_?.APPINSIGHTS_INSTRUMENTATIONKEY ?? 'TBC',
    applicationCopyright: window._env_?.APPLICATION_COPYRIGHT ?? '© Davies Group Ltd. All rights reserved.',
    brandingApiUrl: window._env_?.BRANDING_API_URL ?? 'https://test-brandingapi.davies-group.com/v1.0/clients',
    documentRequestApiUrl: window._env_?.DOCUMENT_REQUEST_API_URL ?? 'https://mock-document-request-api',
    documentApiUrl: window._env_?.DOCUMENT_API_URL ?? 'https://mock-document-api',
    brandId: window._env_?.BRAND_ID ?? 'GRP',
    clientId: window._env_?.CLIENT_ID ?? 'DAV',
    environment: window._env_?.ENVIRONMENT ?? 'Mock',
    invalidRequestId: window._env_?.INVALID_REQUEST_ID ?? 'invalid',
};
